"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appRepositoryMethods = void 0;
const repository_types_1 = require("./repository.types");
exports.appRepositoryMethods = (0, repository_types_1.generateRepositoryMethods)({
    checkFeatureFlag: {
        callMethod: 'GET',
        endpoint: '/feature-flags/check',
    },
    getEnvironmentConfig: {
        callMethod: 'GET',
        endpoint: '/environment/config',
    },
    getAppFeatureFlags: {
        callMethod: 'GET',
        endpoint: '/app/feature-flags',
    },
    getAppConfig: {
        callMethod: 'GET',
        endpoint: '/app/config',
    },
    getApplicationState: {
        callMethod: 'GET',
        endpoint: '/application/state',
    },
    getZipCities: {
        callMethod: 'GET',
        endpoint: '/post-api/zips',
    },
    getPickPostId: {
        callMethod: 'GET',
        endpoint: '/post-api/pick-post-id',
    },
    getCantonByZip: {
        callMethod: 'GET',
        endpoint: '/canton/search',
    },
    getDoctorIsSD: {
        callMethod: 'GET',
        endpoint: '/doctor/is-sd',
    },
    getDoctorIsWhitelisted: {
        callMethod: 'GET',
        endpoint: '/doctor/is-whitelisted',
    },
    getDoctorPreferences: {
        callMethod: 'GET',
        endpoint: '/doctor/preferences',
    },
    sendDailyMedContact: {
        callMethod: 'POST',
        endpoint: '/dailymed/sendContact',
    },
    getWhitelistedPickPosts: {
        callMethod: 'GET',
        endpoint: '/pickpost/whitelisted',
    },
    getCurrentDailymedBoxes: {
        callMethod: 'GET',
        endpoint: '/dailymed/boxes',
    },
    getAllPharmacies: {
        callMethod: 'GET',
        endpoint: '/pharmacies/all',
    },
    setMarketingAutomationContact: {
        callMethod: 'POST',
        endpoint: '/marketingautomation/set-contact',
    },
    getDoctorDetails: {
        callMethod: 'GET',
        endpoint: '/doctor/by-id',
    },
    getShippingLabel: {
        callMethod: 'POST',
        endpoint: '/generate/shipping-label',
    },
    sendContact: {
        callMethod: 'POST',
        endpoint: '/mail/send-contact',
    },
    searchDoctorDetails: {
        callMethod: 'GET',
        endpoint: '/doctor/search',
    },
    getScanditLicenseKey: {
        callMethod: 'GET',
        endpoint: '/scandit/token',
    },
});
//# sourceMappingURL=app.methods.js.map